import { Injectable } from '@angular/core';
import { inputPaymentApiModel, UserDetailAboutCourtFeesApisModel } from '../../models/about-court-fee/about-court-fees';
import { UserDataPayfees } from '../../services/auth/_mock/mock-userdatapayfees.const';
import { inputPaymentModel, UserDetailAboutCourtFeesModel } from '../../view-models/about-court-fees';


import { Mapper } from '../mapper';
@Injectable({
    providedIn: 'root'
})
export class AboutCourtFeesUserPaymentMapper implements Mapper<inputPaymentApiModel, inputPaymentModel>  {
    constructor(

    ) { }
    mapForm(param: inputPaymentApiModel): inputPaymentModel {
        return{
            ...param
        }
    }
    mapTo(param: inputPaymentModel): inputPaymentApiModel {
        return{
            ...param
        }
    }

} 